import { useSelector } from 'react-redux';
import Global from '../../store/global-selectors';
import { useFulfillmentPlannerContext } from '../context';
import { MX } from '../../constants/country-codes';

export const willShipmentPassThroughMexico = (originCountry, destinationCountry) => originCountry === MX || destinationCountry === MX;

export const useShouldRequirePackageContentDescription = () => {
  const { shipFromId, shipTo } = useFulfillmentPlannerContext();

  const origin = useSelector((state) => Global.selectSellerShipFromsById(state, { shipFromId }));
  const originCountry = origin?.originAddress?.countryCode;

  const destination = shipTo;
  const destinationCountry = destination?.countryCode;

  return willShipmentPassThroughMexico(originCountry, destinationCountry);
};
